import { all, call, put, take } from 'redux-saga/effects';
import { get } from 'lodash';
import { notification } from 'antd';

import { CREATE_PATIENT_INF } from '../type';
import {
  createPatientInfErrorAction,
  createPatientInfSuccessAction,
} from '../action';

import MessengerResource from 'common/resource/MessengerResource';

import { accountService } from 'services';

function* createPatient() {
  while (1) {
    const action = yield take(CREATE_PATIENT_INF);
    try {
      const callback = get(action, 'payload.callback');
      const response = yield call(
        accountService.createPatientInfo,
        action.payload,
      );

      callback && callback(response);

      yield put(createPatientInfSuccessAction(response));
    } catch (error) {
      notification.error({
        message: MessengerResource.account.createPatientFail,
        description: error.message,
      });
      yield put(createPatientInfErrorAction(error));
    }
  }
}

export default function* rootSaga() {
  yield all([createPatient()]);
}
